Dropzone.autoDiscover = false;

$(window).on('scroll', function() {
  var scrollTop = $(window).scrollTop();
  $('body')[scrollTop > 0 ? 'addClass' : 'removeClass']('scrolling');
}).trigger('scroll');

agGrid.LicenseManager.setLicenseKey('CompanyName=We Are Sweet Ltd,LicensedApplication=ags,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-015375,ExpiryDate=4_May_2022_[v2]_MTY1MTYxODgwMDAwMA==1eb731a318321fe1271445081094fca8');

function tpy(scope) {
  scope = scope || document;
  $('[data-tippy-content]', scope).each(function() {
    var $this = $(this);
    if($this.attr('data-tippy-content').length) {
      tippy(this, {
        allowHTML: true
      });
    }
  });
}

$(document).ready(function () {
  if(tippy)
  {
    tpy();
  }

  // Geolocation prompts are intentionally disabled across the web app.
  // Keep this branch behind an explicit opt-in flag for future use.
  var enablePassiveLocationSync = false;
  if (
    enablePassiveLocationSync &&
    navigator.geolocation &&
    !$('body').hasClass('login-page') &&
    (
      window.location.pathname.indexOf('sign-off/view') == -1 &&
      window.location.pathname.indexOf('sign-off/thank-you') == -1 &&
      window.location.pathname.indexOf('view-type/choose') == -1 &&
      window.location.pathname.indexOf('subcontractor/view-job') == -1 &&
      window.location.pathname.indexOf('user/recover') == -1
    )
  ) {
    var lastSync = parseInt(localStorage.getItem('core.locationSync')) || 0;
    if (!lastSync || moment(lastSync).isBefore(moment().subtract(1, 'hour'))) {
      console.log('Storing location...');
      navigator.geolocation.getCurrentPosition(function (location) {
        setTimeout(function () {
          $.ajax({
            url: '/user-location/save',
            type: 'post',
            data: {
              lat: location.coords.latitude,
              long: location.coords.longitude
            },
            success: function() {
              localStorage.setItem('core.locationSync', moment().valueOf());
            }
          })
        }, 5000);
      }, function () {});
    } else {
      console.log('Not storing location at this time...');
    }
  }

  $.contextMenu({
    selector: '.pnlm-hotspot.pnlm-tooltip',
    items: {
      viewInstallation: {
        name: "View Installation",
        callback: function(key, opt) {
          window.location = '/installation/index?id=' + opt.$trigger.find('data-container').data('installationId') + '&redirect=/job/wizard';
        }
      },
      deleteTag: {
        name: "Delete Tag",
        callback: function(key, opt) {
          $.confirm({
            title: 'Are you sure?',
            content: 'Are you sure you want to delete this Square Tag?',
            buttons: {
              yes: function() {
                $.ajax({
                  url: '/hotspot/delete?id=' +  opt.$trigger.find('data-container').data('hotspotId'),
                  success: function() {
                    opt.$trigger.remove(); // remove it from the DOM without reloading the 360
                  },
                  error: function() {
                    $.alert('The Square Tag could not be deleted. Please try again later.');
                  }
                })
              },
              no: function() {

              }
            }
          })
        }
      }
    }
  });

  var flashMessage = $('.flash-message.php');
  if(flashMessage.length)
  {
    setTimeout(function() {
      flashMessage.addClass('show');
    }, 80);
  }

  //Used for custom flash messages from run-time js
  window.setFlash = function(message, type) {
    $('.flash-message.js').html(message).addClass('show ' + type);

    setTimeout(function() {
      $('.flash-message.js').removeClass('show');
    }, 3000)
  }

  var satisfaction = $('.satisfaction');

  if(satisfaction.length)
  {
    var satisfactionStars = satisfaction.find('a');

    $('.satisfaction a').on('mouseenter', function() {
      $(this).addClass('hover').parent('li').prevAll().each(function() {
        $(this).find('a').addClass('hover');
      });
    }).on('mouseleave', function() {
      satisfactionStars.removeClass('hover');
    }).on('click', function(e) {
      e.preventDefault();

      var $this = $(this),
        href = $this.attr('href');

      $.confirm({
        title: 'Are you sure?',
        content: 'Once you have submitted your rating, you will not be able to change it. Are you sure?',
        buttons: {
          confirm: function() {
            window.location = href;
          },
          cancel: function() {

          }
        }
      });
    });
  }

  $(document).on('pjax:complete', function() {
    FontAwesome.dom.i2svg()
    tpy();
  });

  $(window).on('load', function() {
    FontAwesome.dom.i2svg()
  });

  $('[data-toggle=tooltip]').tooltip();

  $('#notes').click(function () {
    $('.uplift-notes').addClass('show');
  });

  $('.table-dark').not('#compliance-table').not('.no-float').floatThead({
    top: $('.main-header').height()
  });


  $(document).on('click', '.pnlm-hotspot', function (e) {
    if (!$(e.target).closest('.close').length) {
      $('.pnlm-hotspot').find('span').css('visibility', 'hidden');
      $(this).find('span').css('visibility', 'visible');
    }
  });

  $(document).on('hidden.bs.collapse', function() {
    $('.table-dark').floatThead('reflow');
  });

  $(document).on('shown.bs.collapse', function() {
    $('.table-dark').floatThead('reflow');
  });

  //get this working for ipad

  (function () {
    // Simply add a data-save-tabs to your tablist e.g. <ul role="tablist" data-save-tabs="your-custom-slug">
    $('[data-save-tabs] a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      var savedTabs = JSON.parse(localStorage.getItem('savedTabs'));
      if (typeof savedTabs !== 'object' || !savedTabs) {
        savedTabs = {};
      }
      savedTabs[$(this).closest('[data-save-tabs]').data('save-tabs')] = $(this).attr('href');
      localStorage.setItem('savedTabs', JSON.stringify(savedTabs));
    });

    $('[role="tablist"]').each(function (idx, elem) {
      var savedTabs = JSON.parse(localStorage.getItem('savedTabs'));
      if (typeof savedTabs === 'object') {
        for (var index in savedTabs) {
          if ($(this).data('save-tabs') == index) {
            $('[href="' + savedTabs[index] + '"]').tab('show');
          }
        }
      }
    });
  })(jQuery);


  $(document).on('click', '.pnlm-close', function () {
    //alert('clicked here');
    $(this).parents('span').css('visibility', 'hidden');
    console.log($(this).parents('span'));
  });

  //get this working for ipad

  $(document).on('touchstart', '.pnlm-hotspot', function () {
    // alert('hotspot clicked');
    $(this).trigger('click');
  });

  $('.signature-pad').sfmSignature();


  var element = document.getElementById("message");
  if (element) {
    element.scrollTop = element.scrollHeight;
  }

  $('.check-outside-viewport').each(function() {
    // utility to check if an element is outside the viewport
    var $this = $(this),
      className = 'is-in-viewport';

    if(!$this.inViewport()) {
      className = 'not-in-viewport';
    }

    $this.addClass(className);
  })

  $('.scrollbooster-container').each(function() {
    var viewport = this;

    new ScrollBooster({
      viewport: this,
      content: $(this).children('table').get(0),
      mode: 'x',
      onUpdate: function(data) {
        viewport.scrollLeft = data.position.x
      }
    })
  });

  var sideMenu = $('#side-menu');
  if(sideMenu.length)
  {
    sideMenu.mmenu({
      navbar: {
        title: __SFM.user.profile.name
      },
      extensions: [
        'position-right',
        'pagedim-black',
        'shadow-page'
      ]
    }, {

    });

    $(document).on('click', '[data-toggle-side-menu]', function(e) {
      sideMenu.data('mmenu').open();
      e.preventDefault();
      e.stopPropagation();
    });
  }

  if (window.location.pathname.indexOf('engineer-job') !== -1) {
    $('.installation-live-view').appendTo('body');
  }

  $(document).on('click', '[data-toggle-engineer-context-menu]', function(e) {
    $('.engineer-context-menu').toggleClass('open');
    e.preventDefault();
    e.stopPropagation();
  });

  $(document).on('click', '.overlay-from-right .close', function() {
    closeOverlays();
  })

  window.closeOverlays = function() {
    $('.overlay-from-right').removeClass('active');
    $('body').removeClass('overlay-open');
  };

  window.openOverlay = function(class_name) {
    //Close current overlay
    closeOverlays();

    //Enable required overlay
    $('.' + class_name).addClass('active');

    //Enable overlay
    $('body').addClass('overlay-open');

    tpy('.overlay-from-right');
  };

  $('.table-responsive').scroll(function() {
    $(this).find('table').floatThead('reflow');
  });

  $(document).on('click', '.send-to-save', function(e) {
    e.preventDefault();

    var $this = $(this),
      $sendTo = $this.parents('.send-to'),
      attribute = $sendTo.data('attribute'),
      targetId = $sendTo.data('targetId'),
      targetClass = $sendTo.data('targetClass'),
      userId = $this.parents('.send-to').find('select').val();

    function send(notify) {
      $.ajax({
        url: '/send-to/send',
        type: 'post',
        data: {
          targetId: targetId,
          targetClass: targetClass,
          attribute: attribute,
          notify: notify ? 1 : 0,
          userId: userId
        },
        success: function() {
          $sendTo.find('.send-to-saved').removeClass('d-none');
          $sendTo.find('.send-to-save').addClass('d-none');

          setTimeout(function() {
            $sendTo.find('.send-to-saved').addClass('d-none');
            $sendTo.find('.send-to-save').removeClass('d-none');
          }, 800);
        }
      });
    }
    $.ajax({
      url: '/setting/get',
      data: {
        settings: 'enableOutboundEmails'
      },
      success: function(response) {
        if (!userId) {
          send(false);
        } else {
          $.confirm({
            title: 'Send to',
            content: 'You are about to assign this. Would you like to send an automated notification?',
            columnClass: 'medium',
            buttons: {
              sendWithNotification: {
                text: response.enableOutboundEmails ? 'Send with notification' : 'Outbound emails have been disabled',
                btnClass: 'btn btn-primary',
                isDisabled: !response.enableOutboundEmails,
                action: function() {
                  send(true);
                }
              },
              sendSilently: {
                text: 'Send silently',
                action: function() {
                  send(false);
                }
              },
              cancel: {
                text: 'Cancel'
              }
            }
          });
        }
      }
    })

    return false;
  });

  $(document).on('click', '.team-member-delete', function(e) {
    e.preventDefault();

    var $this = $(this),
      teamMemberId = $this.parents('.team-member').data('teamMemberId');

    $.confirm({
      title: 'Are you sure?',
      content: 'Are you sure you want to remove this person from the team?',
      buttons: {
        confirm: function() {
          $.ajax({
            url: '/team/delete-member',
            type: 'post',
            data: {
              teamMemberId: teamMemberId
            },
            success: function() {
              $.pjax.reload({
                container: '#' + $this.parents('[data-pjax-container]').attr('id'),
                timeout: 10000
              });
            }
          })
        },
        cancel: function() {

        }
      }
    });

    return false;
  });

  $(document).on('change', '.team-member-add-select', function(e) {
    e.preventDefault();

    var $this = $(this),
      teamId = $this.data('teamId'),
      assignableId = $this.val(),
      parent = $this.parents('.team-members-add');

    parent.addClass('loading');

    $.ajax({
      url: '/team/add-member',
      type: 'post',
      data: {
        teamId: teamId,
        assignableId: assignableId
      },
      success: function() {
        $.pjax.reload({
          container: '#' + $this.parents('[data-pjax-container]').attr('id'),
          timeout: 10000
        });
      }
    });

    return false;
  });

  $(document).on('blur', '[data-team-id]', function(e) {
    e.preventDefault();

    var $this = $(this),
      teamId = $this.data('teamId'),
      teamName = $this.val();

    $.ajax({
      url: '/team/update?id=' + teamId,
      type: 'post',
      data: {
        Team: {
          name: teamName
        }
      },
      success: function() {

      }
    });

    return false;
  });

  $(document).on('blur', '[data-asset-group-id]', function(e) {
    e.preventDefault();

    var $this = $(this),
      assetGroupId = $this.data('assetGroupId'),
      assetGroupName = $this.val();

    $.ajax({
      url: '/asset-group/update?id=' + assetGroupId,
      type: 'post',
      data: {
        AssetGroup: {
          name: assetGroupName
        }
      },
      success: function() {

      }
    });

    return false;
  });

  $(document).on('blur', '[data-status-id]', function(e) {
    e.preventDefault();

    var $this = $(this),
      statusId = $this.data('statusId'),
      statusName = $this.val();

    $.ajax({
      url: '/status/update?id=' + statusId,
      type: 'post',
      data: {
        Status: {
          name: statusName
        }
      },
      success: function() {

      }
    });

    return false;
  });

  $(document).on('change', '.status-auto-assign', function(e) {
    var $this = $(this),
      statusId = $this.data('statusId'),
      autoAssign = $this.val();

    $.ajax({
      url: '/status/update?id=' + statusId,
      type: 'post',
      data: {
        Status: {
          auto_assign: autoAssign
        }
      }
    });
  });

  $(document).on('blur', '[data-discipline-id]', function(e) {
    e.preventDefault();

    var $this = $(this),
      disciplineId = $this.data('disciplineId'),
      disciplineName = $this.val();

    $.ajax({
      url: '/discipline/update?id=' + disciplineId,
      type: 'post',
      data: {
        Discipline: {
          name: disciplineName
        }
      },
      success: function() {

      }
    });

    return false;
  });

  $(document).on('click', '.widget-instance-delete', function(e) {
    e.preventDefault();

    var $this = $(this),
      id = $this.data('widgetInstanceId');

    $.confirm({
      title: 'Are you sure?',
      content: 'Are you sure you want to delete this widget from your dashboard?',
      buttons: {
        yes: function() {
          $.ajax({
            url: '/dashboard/delete-widget-instance?id=' + id,
            success: function() {
              window.location.reload()
            }
          });
        },
        no: {}
      }
    });

    return false;
  });

  $(document).on('blur', '.widget-instance-name', function() {
    var $this = $(this),
      instanceId = $this.data('instanceId');

    $.ajax({
      url: '/dashboard/update-widget-instance-name?id=' + instanceId,
      type: 'post',
      data: {
        name: $this.val()
      }
    });
  })
});

// CUSTOM FIELDS
$(document).on('click', '[data-add-condition]', function(e) {
  e.preventDefault();

  var $this = $(this);
  createOrGroup($this.data('addCondition'), $this.data('attributes'));

  return false;
});

function createConditionalFormGroup(form, field, label, attributes, selection) {
  var $conGroup = $('#con-group-template').clone().removeAttr('id').removeClass('d-none');

  $conGroup.find('.name').text('Show ' + label + ' when:');

  $conGroup.appendTo('#form-target-' + form);

  var orGroups = Object.values(selection);

  //POPULATE SELECTS
  $attributeSelect = $conGroup.find('.con-group-attribute');;

  $attributeSelect.append(
    $(document.createElement('option'))
      .text('Please select'));

  for(var i = 0; i < attributes.length; i++) {
    var option = $(document.createElement('option'))
      .attr('value', attributes[i].id)
      .text(attributes[i].name)
      .data('values', attributes[i].values)
      .data('comp_operators', attributes[i].comp_operators)
      .data('entity_type', attributes[i].entity_type)

    $attributeSelect.append(option);
  }

  $conGroup.on('change', '.con-group-attribute', function() {
    refreshConditionalAttributeValues(this);
  });
  //

  //DELETE LISTENERS
  $conGroup.on('click', '.con-group-or-delete', function(e) {
    e.preventDefault();

    var $this = $(this);

    $.confirm({
      title: 'Are you sure?',
      content: 'Are you sure you want to delete this group?',
      buttons: {
        yes: function() {
          $this.parents('.con-group-or').remove();
        },
        no: {

        }
      }
    })

    return false;
  });

  $conGroup.on('click', '.con-group-and-delete', function(e) {
    e.preventDefault();

    var $this = $(this),
      $row = $this.parents('.con-group-and').first();

    $.confirm({
      title: 'Are you sure?',
      content: 'Are you sure you want to delete this condition?',
      buttons: {
        yes: function() {
          $row.remove()
        },
        no: {

        }
      }
    });

    return false;
  });
  //

  $conGroup.on('click', 'button.con-group-and-add', function(e) {
    e.preventDefault();
    createConditionalAndGroup($(this).parents('.con-group-or'), form, field, attributes, [], false);
    return false;
  });

  if (orGroups.length) {
    for (var i = 0; i < orGroups.length; i++) {
      createConditionalOrGroup($conGroup, form, field, attributes, orGroups[i], true);
    }
  } else {
    createConditionalOrGroup($conGroup, form, field, attributes, [], true)
  }

  // CUSTOM FIELDS
  $conGroup.on('click', '[data-add-con-condition]', function(e) {
    e.preventDefault();

    var $this = $(this);
    createConditionalOrGroup($conGroup, form, field, attributes, [], false);

    return false;
  });
  //
}

function createConditionalOrGroup($conGroup, form, field, attributes, selection, empty) {
  var $orGroup = $conGroup.find('.con-group-or').first(),
    $newOrGroup = $orGroup.clone(true, true).removeClass('template'),
    orGroupId = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );

  $newOrGroup.find('.con-group-and:not(:last-of-type)').remove();
  $newOrGroup.find('.con-group-and').addClass('template');

  //SET ATTRIBUTE NAME FOR AND INPUTS WITHIN OR GROUP
  var attributeEntityName = 'FieldGroupConditionals[forms][' + form + '][' + field + '][' + orGroupId + '][entity_type][]';
  var attributeForeignName = 'FieldGroupConditionals[forms][' + form + '][' + field + '][' + orGroupId + '][foreign_id][]';
  var operatorName = 'FieldGroupConditionals[forms][' + form + '][' + field + '][' + orGroupId + '][comp_operator][]';
  var valuesName = 'FieldGroupConditionals[forms][' + form + '][' + field + '][' + orGroupId + '][value][]';

  $newOrGroup.find('.con-group-attribute-hidden').attr('name', attributeEntityName);
  $newOrGroup.find('.con-group-attribute').attr('name', attributeForeignName);
  $newOrGroup.find('.con-group-operator').attr('name', operatorName);
  $newOrGroup.find('.con-group-values').attr('name', valuesName);

  for (var i = 0; i < selection.length; i++) {
    createConditionalAndGroup($newOrGroup, form, field, attributes, selection[i], empty)
  }

  $newOrGroup.insertAfter($conGroup.find('div.con-group-or').last());

  if ($orGroup.hasClass('template') && empty) {
    $orGroup.remove();
  }
}

function createConditionalAndGroup($orGroup, form, field, attributes, values, empty) {
  console.log('creating a new selection', values);

  var $row = $orGroup.find('div.con-group-and').first(),
    $newRow = $row.clone(true, true).removeClass('template');

  $attributeHidden = $newRow.find('.con-group-attribute-hidden');
  $attributeSelect = $newRow.find('.con-group-attribute');
  $attributeComp = $newRow.find('.con-group-operator');
  $attributeValues = $newRow.find('.con-group-values');

  if (values && typeof values == 'object') {
    $attributeHidden.val(values.entity_type);
    $attributeSelect.val(values.foreign_id);

    refreshConditionalAttributeValues($attributeSelect);

    $attributeComp.val(values.comp_operator);
    $attributeValues.val(values.value);
  }

  $newRow.insertAfter($orGroup.find('div.con-group-and').last());

  if ($row.hasClass('template') && empty) {
    $row.remove();
  }
}

function refreshConditionalAttributeValues(el) {
  var $this = $(el),
    selectedOption = $this.find('option:selected'),
    values = selectedOption.data('values'),
    operators = selectedOption.data('comp_operators');

  $this.parents('.con-group-and').find('.con-group-attribute-hidden').val(selectedOption.data('entity_type'));

  $attributeValues = $this.parents('.con-group-and').find('.con-group-values').empty();
  $attributeOperators = $this.parents('.con-group-and').find('.con-group-operator').empty();

  for (var operator in operators) {
    $attributeOperators.append(
      $(document.createElement('option'))
        .text(operators[operator])
        .attr('value', operator)
    );
  }

  var name = $attributeValues.attr('name');

  if (values == null) {
    $attributeValues.replaceWith(
      $(document.createElement('input'))
        .addClass('con-group-values form-control')
        .attr('type', 'text')
        .attr('name', name)
    );

    $attributeValues = $this.parents('.con-group-and').find('.con-group-values').empty();
  } else {
    $attributeValues.replaceWith(
      $(document.createElement('select'))
        .addClass('con-group-values form-control')
        .attr('name', name)
    );

    $attributeValues = $this.parents('.con-group-and').find('.con-group-values').empty();

    for (var optionId in values) {
      if (values.hasOwnProperty(optionId)) {
        var value = values[optionId];

        var option = $(document.createElement('option'))
          .text(value)
          .attr('value', optionId);

        $attributeValues.append(option);
      }
    }
  }
}

function createOrGroup(form, attributes, selection) {
  console.log('creating an or group', arguments);

  selection = selection || {};

  var $orGroup = $('#or-group-template').clone().removeAttr('id').removeClass('d-none'),
    $attributeSelect = $orGroup.find('.or-group-attribute'),
    $attributeFormId = $orGroup.find('.or-group-form-id'),
    $attributeValues = $orGroup.find('.or-group-values'),
    $attributeComp = $orGroup.find('.or-group-operator'),
    $delete = $orGroup.find('.or-group-delete'),
    $and = $orGroup.find('button.or-group-and'),
    $andDelete = $orGroup.find('.or-group-and-delete'),
    _orGroupId = selection.or_group_id ? selection.or_group_id : ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );

  var formId = 'FieldGroupOptions[or_groups][' + _orGroupId + '][' + form + '][field_group_form_id][]';
  var attributeName = 'FieldGroupOptions[or_groups][' + _orGroupId + '][' + form + '][field_group_form_option_id][]';
  var operatorName = 'FieldGroupOptions[or_groups][' + _orGroupId + '][' + form + '][comp_operator][]';
  var valuesName = 'FieldGroupOptions[or_groups][' + _orGroupId + '][' + form + '][value][]';

  $attributeFormId.attr('name', formId);
  $attributeSelect.attr('name', attributeName);
  $attributeComp.attr('name', operatorName);
  $attributeValues.attr('name', valuesName);

  $attributeFormId.attr('value', form);

  function createSelection(values, empty) {
    empty = empty || false;
    console.log('creating a new selection', values);

    var $row = $orGroup.find('div.or-group-and').first(),
      $newRow = $row.clone(true, true).removeClass('template'),
      attribute = $newRow.find('.or-group-attribute');

    if(values)
    {
      attribute.val(values.field_group_form_option_id).trigger('change');
      refreshAttributeValues(attribute);

      $newRow.find('.or-group-operator').val(values.comp_operator);
      $newRow.find('.or-group-values').val(values.value);
      $newRow.insertAfter($row);
    }
    else
    {
      $newRow.insertAfter($orGroup.find('div.or-group-and').last());
    }

    if(empty && $row.hasClass('template'))
    {
      $row.remove();
    }
  }

  $and.on('click', function(e) {
    e.preventDefault();
    createSelection();
    return false;
  });

  $andDelete.on('click', function(e) {
    e.preventDefault();

    var $this = $(this),
      $row = $this.parents('.or-group-and').first();

    $.confirm({
      title: 'Are you sure?',
      content: 'Are you sure you want to delete this condition?',
      buttons: {
        yes: function() {
          $row.remove()
        },
        no: {

        }
      }
    });

    return false;
  });

  $delete.on('click', function(e) {
    e.preventDefault();

    var $this = $(this);

    $.confirm({
      title: 'Are you sure?',
      content: 'Are you sure you want to delete this group?',
      buttons: {
        yes: function() {
          $this.parents('.or-group').remove();
        },
        no: {

        }
      }
    })

    return false;
  });

  $attributeSelect.append(
    $(document.createElement('option'))
      .text('Please select'));

  $(document).on('change', '.or-group-attribute', function() {
    refreshAttributeValues(this);
  });

  function refreshAttributeValues(el) {
    var $this = $(el),
      selectedOption = $this.find('option:selected'),
      values = selectedOption.data('values');

    $attributeValues = $this.parents('.or-group-and').find('.or-group-values').empty();

    for(var optionId in values) {
      if(values.hasOwnProperty(optionId)) {
        var value = values[optionId];

        var option = $(document.createElement('option'))
          .text(value)
          .attr('value', optionId);

        $attributeValues.append(option);
      }
    }
  }

  for(var i = 0; i < attributes.length; i++) {
    var option = $(document.createElement('option'))
      .attr('value', attributes[i].id)
      .text(attributes[i].name)
      .data('values', attributes[i].values);

    $attributeSelect.append(option);
  }

  if(selection.values) {
    for(var i = 0; i < selection.values.length; i++) {
      createSelection(selection.values[i], true);
    }
  }

  $orGroup.appendTo('#form-target-' + form);
}

function updateTaskPhotographs(photos, taskId) {
  for(var i = 0; i < photos.length; i++) {
    var attachment = photos[i];
    var container = $('.task-photographs-container[data-type="' + attachment.attachmentType + '"]').empty();

    for(var j = 0; j < attachment.attachments.length; j++) {
      var a = $(document.createElement('a'));
      a.attr('href', attachment.attachments[j].largeUrl);
      a.addClass('task-photo');
      a.data('id', attachment.attachments[j].id);
      a.data('taskId', taskId);
      a.attr('target', '_blank');

      var img = $(document.createElement('img'));
      img.attr('src', attachment.attachments[j].thumbnailUrl);

      a.append(img);
      container.append(a);
    }
  }
}

$(document).on('click', '.task-photographs[data-task-id]', function(e) {
  e.preventDefault();

  var $this = $(this),
    taskId = $this.data('taskId');

  $.ajax({
    url: '/job/task-photographs?id=' + taskId,
    success: function(response) {
      $('body').addClass('overlay-open');
      $('.overlay-from-right').removeClass('active');
      $('#taskphotoform-task_id').val(taskId);
      $('.task-photographs').addClass('active');
      updateTaskPhotographs(response, taskId);
    }
  });
  return false;
});

$(document).on('beforeSubmit', '#upload-task-photographs', function(e) {
  var form = $(this),
    taskId = $('#taskphotoform-task_id').val();

  $.ajax({
    url: form.attr("action"),
    type: form.attr("method"),
    data: form.serialize(),
    success: function (data) {
      $('.photo-view').show();
      $('.photo-upload').hide();
      updateTaskPhotographs(data, taskId);
      $.pjax.reload({container: '#activity-log-pjax-feed-task-' + taskId, timeout: false});
      Dropzone.forElement('#photo-upload-dropzone').removeAllFiles();
    }
  });

  return false;
}).on('submit', '#upload-task-photographs', function(e) {
  e.preventDefault();
  return false;
})

$(document).on('click', '.job-task-upload-photo', function(e) {
  e.preventDefault();

  var $this = $(this),
    type = $this.data('type');

  $('.photo-view').hide();

  $('#photo-upload-title').text('Add ' + type + ' photos');

  Dropzone.forElement('#photo-upload-dropzone').removeAllFiles();

  $('.photo-upload').show();
  $('#taskphotoform-type').val(type);
  $('#taskphotoform-file_id').val('');

  return false;
});

$(document).on('click', '.photo-upload-back', function(e) {
  e.preventDefault();

  $('.photo-view').show();
  $('.photo-upload').hide();
});

$(function() {
  $.contextMenu({
    selector: '.task-photo',
    items: {
      deletePhoto: {
        name: 'Delete Photo',
        callback: function(key, opt) {
          if(confirm('Are you sure you want to delete this photo?'))
          {
            $.ajax({
              url: '/job/delete-task-photo?id=' + opt.$trigger.data('id'),
              success: function() {
                $.pjax.reload({container: '#activity-log-pjax-feed-task-' + opt.$trigger.data('taskId'), timeout: false});
                opt.$trigger.remove();
              }
            });
          }
        }
      }
    }
  });
});

$(document).on('click', '#unallocated-form button[type=reset]', function(e) {
  e.preventDefault();
  var form = $('#unallocated-form');
  form.get(0).reset();

  setTimeout(function() {
    form.find('select').trigger('change');
  }, 1);

  return false;
}).on('beforeSubmit', '#unallocated-form', function(e) {
  e.preventDefault();
  var form = $('#unallocated-form');
  var hasOne = false;

  form.find('input, select').each(function() {
    var $this = $(this),
      val = $this.val();

    if($this.attr('type') !== 'hidden' && val && val.length) {
      hasOne = true;
    }
  });

  if(!hasOne) {
    alert('Please fill in at least one field');
    return false;
  }

  $.ajax({
    url: form.attr("action"),
    type: form.attr("method"),
    data: form.serialize(),
    success: function (data) {
      $('#unscheduled-form-container').hide();
      $('#unscheduled-results-container').html(data).show();
      tpy('#unscheduled-results-container');
    }
  });

  return false;
});

$(document).on('click', '.unallocated-search-again', function(e) {
  e.preventDefault();
  $('#unscheduled-form-container').show();
  $('#unscheduled-results-container').hide();
  return false;
});

$(document).on('click', '[data-submit-action]', function() {
  var $this = $(this);
  $this.parents('form').data('submitAction', $this.data('submitAction'));
})

//used on job view page to open and collapse custom fields
$(document).on('hide.bs.collapse', '.field-group-collapse', function () {
  $(this).parents().eq(2).addClass('collapsed');
})

$(document).on('show.bs.collapse', '.field-group-collapse', function () {
  $(this).parents().eq(2).removeClass('collapsed');
})

$(document).on('click', '.job-view-toggle-field-group-visibility', function () {

  // Extract the 'id' from the current URL
  const urlParams = new URLSearchParams(window.location.search);
  const jobId = urlParams.get('id');
  var isOpen = !$(this).hasClass('collapsed');
  var fieldGroupId = null;
  var fieldGroup = $(this).closest('.field-group-form-container');

  if(fieldGroup){
    fieldGroupId = fieldGroup.attr('data-fieldgroupid');
  } //console.log("toggle", isOpen, fieldGroupId, jobId)

  if(jobId){
    $.ajax({
      url: '/job-view-job-type-field-group-collapsed/update-collapsed-status',
      type: 'POST',
      data: {
        job_id: jobId,
        field_group_id: fieldGroupId,
        is_open: isOpen
      },
      success: function() {
        console.log('job view job type field group collapsible updated');
      },
      error: function(xhr, error) {
        console.log('job view job type field group collapsible error: ', error);
      }
    });
  }
  else {
    console.log('no job id');
  }
})

// Drag and drop ordering for job view custom field groups (stage 1: UI only)
var jobCustomFieldDragging = null;

function getJobCustomFieldGroupAfterElement(container, y) {
  var elements = Array.prototype.filter.call(container.children, function(el) {
    return el.classList && el.classList.contains('job-custom-field-group') && !el.classList.contains('job-custom-field-group--dragging');
  });
  var closest = null;
  var closestOffset = Number.NEGATIVE_INFINITY;

  Array.prototype.forEach.call(elements, function(el) {
    var box = el.getBoundingClientRect();
    var offset = y - (box.top + box.height / 2);
    if (offset < 0 && offset > closestOffset) {
      closestOffset = offset;
      closest = el;
    }
  });

  return closest;
}

function startJobCustomFieldGroupDrag(e, $group) {
  jobCustomFieldDragging = $group.get(0);
  $group.addClass('job-custom-field-group--dragging');

  var dataTransfer = e.originalEvent.dataTransfer;
  if (dataTransfer) {
    dataTransfer.effectAllowed = 'move';
    dataTransfer.setData('text/plain', '');
    if (dataTransfer.setDragImage) {
      dataTransfer.setDragImage(jobCustomFieldDragging, 10, 10);
    }
  }
}

function endJobCustomFieldGroupDrag() {
  if (jobCustomFieldDragging) {
    $(jobCustomFieldDragging).removeClass('job-custom-field-group--dragging');
  }
  jobCustomFieldDragging = null;
}

$(document).on('dragstart', '.job-custom-field-group', function(e) {
  if (!$(e.target).closest('.job-custom-field-group-handle').length) {
    e.preventDefault();
    return;
  }

  startJobCustomFieldGroupDrag(e, $(this));
});

$(document).on('dragstart', '.job-custom-field-group-handle', function(e) {
  var $group = $(this).closest('.job-custom-field-group');
  if ($group.length) {
    startJobCustomFieldGroupDrag(e, $group);
  }
});

$(document).on('dragend', '.job-custom-field-group', function() {
  endJobCustomFieldGroupDrag();
});

$(document).on('dragend', '.job-custom-field-group-handle', function() {
  endJobCustomFieldGroupDrag();
});

$(document).on('dragover', '.job-custom-fields-sortable', function(e) {
  e.preventDefault();

  var container = this;
  var dragging = jobCustomFieldDragging;
  if (!dragging) {
    return;
  }

  var afterElement = getJobCustomFieldGroupAfterElement(container, e.originalEvent.clientY);
  if (afterElement === null || afterElement.parentNode !== container) {
    container.appendChild(dragging);
  } else {
    container.insertBefore(dragging, afterElement);
  }
});

$(document).on('drop', '.job-custom-fields-sortable', function(e) {
  e.preventDefault();
  var payload = $(this).find('.job-custom-field-group').map(function() {
    return $(this).data('fieldgroupid');
  }).get();

  var urlParams = new URLSearchParams(window.location.search);
  var jobId = urlParams.get('id');

  if (jobId) {
    $.ajax({
      url: '/job-view-job-type-field-group-order/update-order',
      type: 'POST',
      data: {
        job_id: jobId,
        order: payload
      },
      success: function() {},
      error: function() {}
    });
  }
});

$(document).on('click', '.job-custom-fields-help-toggle', function() {
  var $help = $(this).closest('.job-custom-fields-help');
  var willCollapse = !$help.hasClass('is-collapsed');
  $help.toggleClass('is-collapsed', willCollapse);

  $.ajax({
    url: '/job-view-help-state/update',
    type: 'POST',
    data: {
      is_collapsed: willCollapse ? 1 : 0
    },
    success: function() {},
    error: function() {}
  });
});
